var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"app-employment-type-alias-dialog app-from--hide-details ma-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Название","box":""},model:{value:(_vm.model.name),callback:function ($$v) {_vm.$set(_vm.model, "name", $$v)},expression:"model.name"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }